import {
  IdleAssetReconciliationCreateSchema,
  IdleAssetReconciliationNoOpSchema,
  type IdleAssetReconciliationCreate,
  type IdleAssetReconciliationNoOp,
} from "@repo/execution-engine-contracts/idle-reconciliation";

export {
  CanonicalSellAmountSchema,
  CanonicalSellCreateRequestSchema,
} from "@repo/execution-engine-contracts/canonical-sells";
export { AssetTradeCreateRequestSchema } from "@repo/execution-engine-contracts/asset-trades";
export type { CanonicalSellProgress } from "@repo/execution-engine-contracts/canonical-sells";
import {
  CanonicalSellProgressSchema,
  type CanonicalSellProgress,
} from "@repo/execution-engine-contracts/canonical-sells";
export type {
  PortfolioCashFunding,
  PortfolioOrder,
  PortfolioOrderCreate,
  PortfolioOrderCreated,
} from "@repo/execution-engine-contracts/portfolio-orders";
export type {
  AssetTradeCanonicalBuyCreateRequest,
  AssetTradeCanonicalBuyPreviewRequest,
  AssetTradeConcreteCreateRequest,
  AssetTradeConcretePreviewRequest,
  AssetTradeCreateRequest,
  AssetTradeDisabledReason,
  AssetTradeFunding,
  AssetTradeFundingRecoveryResponse,
  AssetTradeMaxRequest,
  AssetTradeMaxResponse,
  AssetTradeOperationResponse,
  AssetTradePlanBasis,
  AssetTradePlanBasisResolution,
  AssetTradePreviewRequest,
  AssetTradePreviewResponse,
  AssetTradeResolvedRoute,
} from "@repo/execution-engine-contracts/asset-trades";
export { AssetTradeMaxResponseSchema } from "@repo/execution-engine-contracts/asset-trades";
export type {
  CanonicalSellAmount,
  CanonicalSellCreateRequest,
  CanonicalSellMaxRequest,
  CanonicalSellMaxResponse,
  CanonicalSellPlanBasis,
  CanonicalSellPreviewRequest,
  CanonicalSellPreviewResponse,
  CanonicalSellOperationResponse,
} from "@repo/execution-engine-contracts/canonical-sells";
import {
  CanonicalSellCreateRequestSchema,
  CanonicalSellMaxRequestSchema,
  CanonicalSellMaxResponseSchema,
  CanonicalSellOperationResponseSchema,
  CanonicalSellPreviewRequestSchema,
  CanonicalSellPreviewResponseSchema,
  type CanonicalSellMaxResponse,
  type CanonicalSellPreviewResponse,
  type CanonicalSellOperationResponse,
} from "@repo/execution-engine-contracts/canonical-sells";
import {
  AssetTradeCreateRequestSchema,
  AssetTradeFundingRecoveryResponseSchema,
  AssetTradeMaxRequestSchema,
  AssetTradeMaxResponseSchema,
  AssetTradeOperationResponseSchema,
  AssetTradePreviewRequestSchema,
  AssetTradePreviewResponseSchema,
  type AssetTradeFunding,
  type AssetTradeMaxResponse,
  type AssetTradeOperationResponse,
  type AssetTradePreviewResponse,
} from "@repo/execution-engine-contracts/asset-trades";
import {
  WithdrawalBalancesInputSchema,
  WithdrawalBalancesSchema,
  type WithdrawalBalances,
  type WithdrawalBalancesInput,
} from "@repo/execution-engine-contracts/withdrawal-balances";
export {
  WithdrawalBalancesInputSchema,
  WithdrawalBalancesSchema,
  type WithdrawalBalances,
  type WithdrawalBalancesInput,
} from "@repo/execution-engine-contracts/withdrawal-balances";
import {
  PortfolioCashFundingSchema,
  type PortfolioCashFunding,
  PortfolioOrderCreateSchema,
  PortfolioOrderCreatedSchema,
  PortfolioOrderSchema,
  type PortfolioOrder,
  type PortfolioOrderCreate,
  type PortfolioOrderCreated,
} from "@repo/execution-engine-contracts/portfolio-orders";
import * as SharedRequestContracts from "@repo/execution-engine-contracts/requests";
import {
  executionOwnerUsdcWithdrawalCreateSchema,
  executionOwnerUsdcWithdrawalPreviewInputSchema,
} from "@repo/execution-engine-contracts/owner-usdc-withdrawal";
import {
  exactSelectionWithdrawalAckSchema,
  exactSelectionWithdrawalCreateSchema,
  exactSelectionWithdrawalIdentitySchema,
  type ExactSelectionWithdrawalAck,
  type ExactSelectionWithdrawalCreate,
  type ExactSelectionWithdrawalIdentity,
} from "@repo/execution-engine-contracts/exact-selection-withdrawal";
export {
  countOwnerUsdcWithdrawalActions,
  executionOwnerUsdcWithdrawalCreateSchema,
  MAX_OWNER_USDC_WITHDRAWAL_ASSETS,
} from "@repo/execution-engine-contracts/owner-usdc-withdrawal";
import {
  executionExternalWithdrawalCreateSchema,
  executionExternalWithdrawalPreviewInputSchema,
  executionExternalWithdrawalPreviewSchema,
} from "@repo/execution-engine-contracts/external-withdrawal";
export {
  executionExternalWithdrawalCreateSchema,
  executionExternalWithdrawalPreviewInputSchema,
  executionExternalWithdrawalPreviewSchema,
};
import {
  ExecutionLiveClientMessageSchema,
  ExecutionLiveEventSchema,
  ExecutionLiveServerMessageSchema,
  ExecutionLiveSnapshotSchema,
  ExecutionOndoDirectRebalancePlanPreviewSchema,
  ExecutionOperationEventAckSchema,
  ExecutionOperationResponseSchema,
  ExecutionRebalanceCreateResponseSchema,
  LiveDescriptorSchema,
  PortfolioExecutionFeedClientMessageSchema,
  PortfolioExecutionFeedOperationSchema,
  PortfolioExecutionFeedServerMessageSchema,
  PortfolioExecutionFeedSnapshotSchema,
  PortfolioFeedLiveDescriptorSchema,
  UserExecutionFeedClientMessageSchema,
  UserExecutionFeedOperationSchema,
  UserExecutionFeedServerMessageSchema,
  UserExecutionFeedSnapshotSchema,
  UserFeedLiveDescriptorSchema,
  OndoDirectRebalancePlanSchema,
} from "@repo/execution-engine-contracts/responses";
import type { ExecutionLiveJsonValue } from "@repo/execution-engine-contracts/responses";
import type { CapabilityScope } from "@repo/capability-token";
import { z } from "zod";

export {
  ExecutionLiveClientMessageSchema,
  ExecutionLiveEventSchema,
  ExecutionLiveServerMessageSchema,
  ExecutionLiveSnapshotSchema,
  ExecutionOndoDirectRebalancePlanPreviewSchema,
  ExecutionOperationEventAckSchema,
  ExecutionOperationResponseSchema,
  ExecutionRebalanceCreateResponseSchema,
  LiveDescriptorSchema,
  PortfolioExecutionFeedClientMessageSchema,
  PortfolioExecutionFeedOperationSchema,
  PortfolioExecutionFeedServerMessageSchema,
  PortfolioExecutionFeedSnapshotSchema,
  PortfolioFeedLiveDescriptorSchema,
  UserExecutionFeedClientMessageSchema,
  UserExecutionFeedOperationSchema,
  UserExecutionFeedServerMessageSchema,
  UserExecutionFeedSnapshotSchema,
  UserFeedLiveDescriptorSchema,
  OndoDirectRebalancePlanSchema,
};

const DEFAULT_REQUEST_TIMEOUT_MS = 10_000;
// Admission acquires authoritative multichain snapshots before acknowledging an order.
const PORTFOLIO_ORDER_ADMISSION_TIMEOUT_MS = 60_000;
/**
 * The chain namespaces the engine's trade routes serve: EVM chains, and
 * Solana mainnet from an Investing Account's Solana vault (the engine's
 * Solana trade lane). Whether a given account can trade on a namespace is
 * the caller's question (the account must custody a vault there); this only
 * says the engine has a lane for it.
 */
export const EXECUTION_ENGINE_SUPPORTED_CHAIN_NAMESPACES = [
  "eip155",
  "solana",
] as const;
export type ExecutionEngineSupportedChainNamespace =
  (typeof EXECUTION_ENGINE_SUPPORTED_CHAIN_NAMESPACES)[number];

export const isExecutionEngineSupportedChainNamespace = (
  namespace: string,
): namespace is ExecutionEngineSupportedChainNamespace =>
  namespace === "eip155" || namespace === "solana";

export type ExecutionEngineLiveJsonValue = ExecutionLiveJsonValue;

const ExecutionCorrelationIdSchema =
  SharedRequestContracts.ExecutionCorrelationIdSchema;

const executionOperationCreateSchema =
  SharedRequestContracts.executionOperationCreateSchema;
const executionOndoDirectBatchRebalanceCreateSchema =
  SharedRequestContracts.executionOndoDirectBatchRebalanceCreateSchema.superRefine(
    (input, ctx) => {
      // Preserve the BASE client's cross-leg admission rules without imposing
      // them on the shared Worker contract. The leg-vs-cash assetId rule lives
      // in the shared schema (both sides reject), so only uniqueness and the
      // token-address/cash overlap remain client-side.
      const cashTokenKey = input.cashTokenAddress.toLowerCase();
      const seenAssetIds = new Set<string>();
      const seenTokenAddresses = new Set<string>();
      const legs = [
        ...(input.sells ?? []).map((leg, index) => ({
          leg,
          side: "sells" as const,
          index,
        })),
        ...(input.buys ?? []).map((leg, index) => ({
          leg,
          side: "buys" as const,
          index,
        })),
      ];

      for (const { leg, side, index } of legs) {
        const assetKey = leg.assetId.toLowerCase();
        if (seenAssetIds.has(assetKey)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "duplicate assetId across Ondo Direct batch legs",
            path: [side, index, "assetId"],
          });
        }
        seenAssetIds.add(assetKey);

        if (leg.assetTokenAddress !== undefined) {
          const tokenKey = leg.assetTokenAddress.toLowerCase();
          if (tokenKey === cashTokenKey) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message:
                "Ondo Direct batch leg assetTokenAddress must differ from cashTokenAddress",
              path: [side, index, "assetTokenAddress"],
            });
          }
          if (seenTokenAddresses.has(tokenKey)) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message:
                "duplicate assetTokenAddress across Ondo Direct batch legs",
              path: [side, index, "assetTokenAddress"],
            });
          }
          seenTokenAddresses.add(tokenKey);
        }
      }
    },
  );
const OndoDirectRebalanceTargetSchema =
  SharedRequestContracts.OndoDirectRebalanceTargetSchema;
const executionOndoDirectRebalancePlanCreateSchema =
  SharedRequestContracts.executionOndoDirectRebalancePlanCreateSchema;
const executionOndoDirectRebalancePlanPreviewRequestSchema =
  SharedRequestContracts.executionOndoDirectRebalancePlanPreviewSchema;
const executionWithdrawalCreateSchema =
  SharedRequestContracts.executionWithdrawalCreateSchema;
const executionWithdrawalPreviewInputSchema =
  SharedRequestContracts.executionWithdrawalPreviewInputSchema;
const executionWithdrawalPreviewSchema =
  SharedRequestContracts.executionWithdrawalPreviewSchema;
export const executionOwnerWithdrawalCreateSchema =
  SharedRequestContracts.executionOwnerWithdrawalCreateSchema;
export const MAX_OWNER_WITHDRAWAL_ASSETS =
  SharedRequestContracts.MAX_EXECUTION_OPERATION_ACTIONS;
export const MAX_EXECUTION_OPERATION_ACTIONS =
  SharedRequestContracts.MAX_EXECUTION_OPERATION_ACTIONS;
export type ExecutionEngineOwnerWithdrawalInput = z.input<
  typeof executionOwnerWithdrawalCreateSchema
>;
export type ExecutionEngineOwnerUsdcWithdrawalInput = z.input<
  typeof executionOwnerUsdcWithdrawalCreateSchema
>;
const executionOwnerWithdrawalPreviewInputSchema =
  SharedRequestContracts.executionOwnerWithdrawalPreviewInputSchema;
const executionOwnerWithdrawalPreviewSchema =
  SharedRequestContracts.executionOwnerWithdrawalPreviewSchema;
export type ExecutionEngineOwnerWithdrawalPreviewInput = z.input<
  typeof executionOwnerWithdrawalPreviewInputSchema
>;
export type ExecutionEngineOwnerUsdcWithdrawalPreviewInput = z.input<
  typeof executionOwnerUsdcWithdrawalPreviewInputSchema
>;
export type ExecutionEngineOwnerWithdrawalPreview = z.infer<
  typeof executionOwnerWithdrawalPreviewSchema
>;
export type ExecutionEngineExternalWithdrawalPreviewInput = z.input<
  typeof executionExternalWithdrawalPreviewInputSchema
>;
export type ExecutionEngineExternalWithdrawalInput = z.input<
  typeof executionExternalWithdrawalCreateSchema
>;
export type ExecutionEngineExternalWithdrawalPreview = z.infer<
  typeof executionExternalWithdrawalPreviewSchema
>;
const executionTransferCreateSchema =
  SharedRequestContracts.executionTransferCreateSchema;
const executionBridgeCreateSchema =
  SharedRequestContracts.executionBridgeCreateSchema;
const executionDepositIntentCreateSchema =
  SharedRequestContracts.executionDepositIntentCreateSchema;
const executionDepositTransactionAttachSchema =
  SharedRequestContracts.executionDepositTransactionAttachSchema;
const DepositTransferReferenceSchema =
  SharedRequestContracts.DepositTransferReferenceSchema;
const executionOperationEventSchema =
  SharedRequestContracts.executionOperationEventSchema;
const executionOperationSettlementAckSchema =
  SharedRequestContracts.executionOperationSettlementAckSchema;
const rebalanceCreateSchema = SharedRequestContracts.rebalanceCreateSchema;

const executionLiveServerMessageKinds: ReadonlySet<string> = new Set(
  ExecutionLiveServerMessageSchema.options.map(
    (option) => option.shape.kind.value,
  ),
);
const portfolioExecutionFeedServerMessageKinds: ReadonlySet<string> = new Set(
  PortfolioExecutionFeedServerMessageSchema.options.map(
    (option) => option.shape.kind.value,
  ),
);
const userExecutionFeedServerMessageKinds: ReadonlySet<string> = new Set(
  UserExecutionFeedServerMessageSchema.options.map(
    (option) => option.shape.kind.value,
  ),
);

export type ExecutionEngineCreateInput = z.input<
  typeof executionOperationCreateSchema
>;
export type ExecutionEngineRebalanceInput = z.input<
  typeof rebalanceCreateSchema
>;
export type ExecutionEngineRebalanceOperation = z.infer<
  typeof ExecutionRebalanceCreateResponseSchema
>;
export type ExecutionEngineOndoDirectBatchRebalanceInput = z.input<
  typeof executionOndoDirectBatchRebalanceCreateSchema
>;
export type ExecutionEngineOndoDirectRebalanceTarget = z.infer<
  typeof OndoDirectRebalanceTargetSchema
>;
export type ExecutionEngineOndoDirectRebalancePlanInput = z.input<
  typeof executionOndoDirectRebalancePlanCreateSchema
>;
export type ExecutionEngineOndoDirectRebalancePlanPreviewInput = z.input<
  typeof executionOndoDirectRebalancePlanPreviewRequestSchema
>;
export type ExecutionEngineOndoDirectRebalancePlan = z.infer<
  typeof OndoDirectRebalancePlanSchema
>;
export type ExecutionEngineOndoDirectRebalancePlanPreview = z.infer<
  typeof ExecutionOndoDirectRebalancePlanPreviewSchema
>;
export type ExecutionEngineWithdrawalInput = z.input<
  typeof executionWithdrawalCreateSchema
>;
export type ExecutionEngineWithdrawalPreviewInput = z.input<
  typeof executionWithdrawalPreviewInputSchema
>;
export type ExecutionEngineWithdrawalPreview = z.infer<
  typeof executionWithdrawalPreviewSchema
>;
export type ExecutionEngineWithdrawalFee =
  ExecutionEngineWithdrawalPreview["fees"][number];
export type ExecutionEngineTransferInput = z.input<
  typeof executionTransferCreateSchema
>;
export type ExecutionEngineBridgeInput = z.input<
  typeof executionBridgeCreateSchema
>;
export type ExecutionEngineDepositIntentInput = z.input<
  typeof executionDepositIntentCreateSchema
>;
export type ExecutionEngineDepositAttachInput = z.input<
  typeof executionDepositTransactionAttachSchema
>;
export type ExecutionEngineDepositTransferReference = z.infer<
  typeof DepositTransferReferenceSchema
>;
export type ExecutionEngineEventInput = z.input<
  typeof executionOperationEventSchema
>;
export type ExecutionEngineSettlementAckInput = z.input<
  typeof executionOperationSettlementAckSchema
>;

const normalizeOndoDirectZeroMinimums = (
  input: ExecutionEngineOndoDirectBatchRebalanceInput,
): ExecutionEngineOndoDirectBatchRebalanceInput => ({
  ...input,
  ...(input.sells
    ? {
        sells: input.sells.map((leg) => ({
          ...leg,
          minCashOutRaw:
            leg.minCashOutRaw === "0" ? undefined : leg.minCashOutRaw,
        })),
      }
    : {}),
  ...(input.buys
    ? {
        buys: input.buys.map((leg) => ({
          ...leg,
          minTokenOutRaw:
            leg.minTokenOutRaw === "0" ? undefined : leg.minTokenOutRaw,
        })),
      }
    : {}),
});
export type ExecutionEngineOperation = z.infer<
  typeof ExecutionOperationResponseSchema
>;
export type ExecutionEngineLiveDescriptor = z.infer<
  typeof LiveDescriptorSchema
>;
export type ExecutionEngineUserFeedLiveDescriptor = z.infer<
  typeof UserFeedLiveDescriptorSchema
>;
export type ExecutionEngineEventAck = z.infer<
  typeof ExecutionOperationEventAckSchema
>;
export type ExecutionLiveSnapshot = z.infer<typeof ExecutionLiveSnapshotSchema>;
export type ExecutionLiveEvent = z.infer<typeof ExecutionLiveEventSchema>;
export type ExecutionLiveClientMessage = z.infer<
  typeof ExecutionLiveClientMessageSchema
>;
export type ExecutionLiveServerMessage = z.infer<
  typeof ExecutionLiveServerMessageSchema
>;
export type PortfolioExecutionFeedSnapshot = z.infer<
  typeof PortfolioExecutionFeedSnapshotSchema
>;
export type PortfolioExecutionFeedOperation = z.infer<
  typeof PortfolioExecutionFeedOperationSchema
>;
export type PortfolioExecutionFeedClientMessage = z.infer<
  typeof PortfolioExecutionFeedClientMessageSchema
>;
export type PortfolioExecutionFeedServerMessage = z.infer<
  typeof PortfolioExecutionFeedServerMessageSchema
>;
export type UserExecutionFeedSnapshot = z.infer<
  typeof UserExecutionFeedSnapshotSchema
>;
export type UserExecutionFeedOperation = z.infer<
  typeof UserExecutionFeedOperationSchema
>;
export type UserExecutionFeedClientMessage = z.infer<
  typeof UserExecutionFeedClientMessageSchema
>;
export type UserExecutionFeedServerMessage = z.infer<
  typeof UserExecutionFeedServerMessageSchema
>;

export class ExecutionEngineClientError extends Error {
  constructor(
    message: string,
    readonly code:
      | "EXECUTION_ENGINE_NOT_CONFIGURED"
      | "EXECUTION_ENGINE_REQUEST_FAILED"
      | "EXECUTION_ENGINE_NOT_FOUND"
      | "EXECUTION_ENGINE_INVALID_RESPONSE",
    readonly status?: number,
    readonly details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = "ExecutionEngineClientError";
  }
}

type FetchLike = (input: string, init?: RequestInit) => Promise<Response>;
export type ExecutionEngineRequestOptions = {
  readonly signal?: AbortSignal;
  /**
   * Overrides the client's timeout for this one request. Quoting routes
   * (trade preview and create with funding legs, portfolio orders) gather
   * quotes from venues and bridges: a funded Solana buy preview took 8 s on a
   * local stack against the client's 10 s default. Reads keep the default.
   */
  readonly requestTimeoutMs?: number;
  readonly capability?: {
    readonly portfolioIds?: readonly string[];
    readonly scopes?: readonly CapabilityScope[];
  };
  /**
   * Optional correlation for requests without a correlation-bearing body
   * (for example GETs and event attachments). Create requests derive this
   * automatically from their validated `correlationId` input.
   */
  readonly telemetry?: {
    readonly clientInteractionId?: string;
    readonly correlationId?: string;
  };
};

export type ExecutionEngineRequestContext = {
  readonly body?: string;
  readonly method: "GET" | "POST";
  readonly options?: ExecutionEngineRequestOptions;
  readonly path: string;
};

type HeaderProvider = (
  context?: ExecutionEngineRequestContext,
) => Promise<Record<string, string>> | Record<string, string>;
type CapabilityUnauthorizedHandler = (
  context?: ExecutionEngineRequestContext,
) => Promise<unknown> | unknown;
type WebSocketLike = Pick<
  WebSocket,
  "addEventListener" | "close" | "readyState" | "removeEventListener" | "send"
>;
type WebSocketConstructorLike = new (
  url: string | URL,
  protocols?: string | string[],
) => WebSocketLike;

const normalizeOptionalString = (
  value: string | null | undefined,
): string | null => {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

const normalizeBaseUrl = (value: string): string => value.replace(/\/+$/u, "");

export const buildExecutionLiveWebSocketUrl = (params: {
  readonly baseUrl: string;
  readonly operationId: string;
}): string => {
  const url = new URL(
    `/execution/operations/${encodeURIComponent(params.operationId)}/live`,
    normalizeBaseUrl(params.baseUrl),
  );
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
};

export const buildPortfolioExecutionFeedWebSocketUrl = (params: {
  readonly baseUrl: string;
  readonly portfolioId: string;
}): string => {
  const url = new URL(
    `/execution/portfolios/${encodeURIComponent(params.portfolioId)}/live`,
    normalizeBaseUrl(params.baseUrl),
  );
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
};

export const buildUserExecutionFeedWebSocketUrl = (params: {
  readonly baseUrl: string;
  readonly userId: string;
}): string => {
  const url = new URL(
    `/execution/users/${encodeURIComponent(params.userId)}/activity/live`,
    normalizeBaseUrl(params.baseUrl),
  );
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
};

const EXECUTION_FEED_SUBPROTOCOL = "glider.feed.v1";
const EXECUTION_FEED_TOKEN_SUBPROTOCOL_PREFIX = "token.";

const buildExecutionFeedSubprotocols = (
  token: string | null | undefined,
): string[] => [
  EXECUTION_FEED_SUBPROTOCOL,
  ...(token ? [`${EXECUTION_FEED_TOKEN_SUBPROTOCOL_PREFIX}${token}`] : []),
];

const readErrorPayload = async (
  response: Response,
): Promise<{ message: string; details?: Record<string, unknown> }> => {
  const text = await response.text();
  try {
    const payload = JSON.parse(text) as unknown;
    const details =
      typeof payload === "object" && payload !== null
        ? (payload as Record<string, unknown>)
        : undefined;
    const message =
      typeof details?.message === "string" && details.message.trim().length > 0
        ? details.message.trim()
        : typeof details?.error === "string" && details.error.trim().length > 0
          ? details.error.trim()
          : `status ${response.status}`;

    return {
      message,
      ...(details ? { details } : {}),
    };
  } catch {
    const trimmed = text.trim();
    // Short plain-text bodies are useful diagnostics; HTML error pages and
    // other long payloads are not API messages — surface the status instead
    // of dumping markup on callers.
    const isUsableText =
      trimmed.length > 0 && trimmed.length <= 300 && !trimmed.startsWith("<");
    return {
      message: isUsableText ? trimmed : `status ${response.status}`,
    };
  }
};

const withTimeout = async <T>(
  timeoutMs: number,
  run: (signal: AbortSignal) => Promise<T>,
): Promise<T> => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await run(controller.signal);
  } finally {
    clearTimeout(timeout);
  }
};

/**
 * Static keepalive control frames. These MUST byte-match
 * `REALTIME_FEED_KEEPALIVE_REQUEST` / `REALTIME_FEED_KEEPALIVE_RESPONSE` in
 * `@repo/realtime-feed/protocol` so the Durable Object's
 * `setWebSocketAutoResponse` pair matches the request exactly and answers it
 * WITHOUT waking the hibernated DO. Duplicated (not imported) to keep this
 * browser-bundled client free of a `@repo/realtime-feed` dependency; the client
 * WS tests pin the exact bytes.
 */
const REALTIME_FEED_KEEPALIVE_REQUEST = '{"kind":"keepalive"}';
const REALTIME_FEED_KEEPALIVE_ACK_KIND = "keepalive_ack";

/**
 * How often the client sends the static keepalive frame on an otherwise-idle
 * socket, and how long it tolerates silence before declaring the socket dead.
 * CF/NAT reap idle sockets with no notification, so without this a parked
 * operation's feed goes quietly stale. The watchdog closes the socket so the
 * consumer's existing `onClose` reconnect path fires.
 */
const KEEPALIVE_INTERVAL_MS = 20_000;
const STALE_CONNECTION_TIMEOUT_MS = 40_000;

type SubscriptionSocket = Pick<WebSocketLike, "close" | "send">;

type LivenessGuard = {
  /** Start the keepalive interval + stale watchdog (call on socket open). */
  readonly start: () => void;
  /** Record an inbound frame of any kind, re-arming the stale watchdog. */
  readonly noteActivity: () => void;
  /** Clear all timers (call on close/unsubscribe). */
  readonly dispose: () => void;
};

const isKeepaliveAck = (value: unknown): boolean =>
  typeof value === "object" &&
  value !== null &&
  (value as { readonly kind?: unknown }).kind ===
    REALTIME_FEED_KEEPALIVE_ACK_KIND;

const hasUnknownFrameKind = (
  value: unknown,
  knownKinds: ReadonlySet<string>,
): boolean => {
  if (
    typeof value !== "object" ||
    value === null ||
    !("kind" in value) ||
    typeof value.kind !== "string"
  ) {
    return false;
  }

  return !knownKinds.has(value.kind);
};

/**
 * Client-side keepalive + stale-connection watchdog, internal to every subscribe
 * helper so all four webapp feed hooks inherit it with no call-site change.
 */
const createLivenessGuard = (socket: SubscriptionSocket): LivenessGuard => {
  let keepaliveTimer: ReturnType<typeof setInterval> | null = null;
  let watchdogTimer: ReturnType<typeof setTimeout> | null = null;

  const clearWatchdog = (): void => {
    if (watchdogTimer !== null) {
      clearTimeout(watchdogTimer);
      watchdogTimer = null;
    }
  };

  const armWatchdog = (): void => {
    clearWatchdog();
    watchdogTimer = setTimeout(() => {
      // No frame (data, pong, or keepalive_ack) within the stale window: the
      // socket is silently dead. Close it so the consumer's reconnect fires.
      try {
        socket.close();
      } catch {
        // Already closing/closed; nothing to do.
      }
    }, STALE_CONNECTION_TIMEOUT_MS);
  };

  return {
    start: () => {
      armWatchdog();
      keepaliveTimer = setInterval(() => {
        try {
          socket.send(REALTIME_FEED_KEEPALIVE_REQUEST);
        } catch {
          // Socket closing/closed between ticks; the watchdog/close path handles it.
        }
      }, KEEPALIVE_INTERVAL_MS);
    },
    noteActivity: () => {
      armWatchdog();
    },
    dispose: () => {
      clearWatchdog();
      if (keepaliveTimer !== null) {
        clearInterval(keepaliveTimer);
        keepaliveTimer = null;
      }
    },
  };
};

export type ExecutionEngineClient = {
  readonly lookupExactSelectionWithdrawal?: (
    input: ExactSelectionWithdrawalIdentity,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExactSelectionWithdrawalAck | null>;
  readonly createExactSelectionWithdrawal?: (
    input: ExactSelectionWithdrawalCreate,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExactSelectionWithdrawalAck>;
  readonly getCanonicalSellMax?: (
    input: z.input<typeof CanonicalSellMaxRequestSchema>,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<CanonicalSellMaxResponse>;
  readonly previewCanonicalSell?: (
    input: z.input<typeof CanonicalSellPreviewRequestSchema>,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<CanonicalSellPreviewResponse>;
  readonly createCanonicalSell?: (
    input: z.input<typeof CanonicalSellCreateRequestSchema>,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<CanonicalSellOperationResponse>;
  readonly getPortfolioCashFunding?: (
    portfolioId: string,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<PortfolioCashFunding>;
  readonly createPortfolioOrder?: (
    input: PortfolioOrderCreate,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<PortfolioOrderCreated>;
  readonly getPortfolioOrder?: (
    portfolioId: string,
    operationId: string,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<PortfolioOrder>;
  readonly getWithdrawalBalances?: (
    input: WithdrawalBalancesInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<WithdrawalBalances>;
  /**
   * The most the engine would accept as this trade's `amount` right now:
   * `cashRaw` for a buy, `assetRaw` for a sell, with a reason when zero.
   */
  readonly getTradeMax?: (
    input: z.input<typeof AssetTradeMaxRequestSchema>,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<AssetTradeMaxResponse>;
  readonly createOperation: {
    (
      input: ExecutionEngineCreateInput,
      options?: ExecutionEngineRequestOptions,
    ): Promise<ExecutionEngineOperation>;
    (
      input: IdleAssetReconciliationCreate,
      options?: ExecutionEngineRequestOptions,
    ): Promise<ExecutionEngineOperation | IdleAssetReconciliationNoOp>;
  };
  readonly createRebalance?: (
    input: ExecutionEngineRebalanceInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineRebalanceOperation>;
  /**
   * The asset-trade front door: the engine chooses cash, venue, funding,
   * minimums, and market-hours handling. Submit the preview's `planBasis`
   * to `createAssetTrade` unchanged.
   */
  readonly previewAssetTrade?: (
    input: z.input<typeof AssetTradePreviewRequestSchema>,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<AssetTradePreviewResponse>;
  readonly createAssetTrade?: (
    input: z.input<typeof AssetTradeCreateRequestSchema>,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<AssetTradeOperationResponse>;
  /**
   * The funding plan a funded buy persisted at admission, for live-progress
   * recovery after a lost create response; `null` when no cash moved first.
   */
  readonly getCanonicalSellProgress?: (
    operationId: string,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<CanonicalSellProgress>;
  readonly getAssetTradeFunding?: (
    operationId: string,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<AssetTradeFunding | null>;
  readonly createOndoDirectBatchRebalance: (
    input: ExecutionEngineOndoDirectBatchRebalanceInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly createOndoDirectRebalanceFromTargets: (
    input: ExecutionEngineOndoDirectRebalancePlanInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly previewOndoDirectRebalancePlan: (
    input: ExecutionEngineOndoDirectRebalancePlanPreviewInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOndoDirectRebalancePlanPreview>;
  readonly createWithdrawal: (
    input: ExecutionEngineWithdrawalInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  /** What a first-class withdrawal would pay its recipient, and its fees. */
  readonly previewWithdrawal?: (
    input: ExecutionEngineWithdrawalPreviewInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineWithdrawalPreview>;
  readonly createOwnerWithdrawal?: (
    input: ExecutionEngineOwnerWithdrawalInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly createOwnerUsdcWithdrawal?: (
    input: ExecutionEngineOwnerUsdcWithdrawalInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  /** The onramp fee repayment an in-kind owner withdrawal would carry. */
  readonly previewOwnerWithdrawal?: (
    input: ExecutionEngineOwnerWithdrawalPreviewInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOwnerWithdrawalPreview>;
  /** The onramp fee repayment an owner USDC withdrawal would carry. */
  readonly previewOwnerUsdcWithdrawal?: (
    input: ExecutionEngineOwnerUsdcWithdrawalPreviewInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOwnerWithdrawalPreview>;
  readonly previewExternalWithdrawal?: (
    input: ExecutionEngineExternalWithdrawalPreviewInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineExternalWithdrawalPreview>;
  readonly createExternalWithdrawal?: (
    input: ExecutionEngineExternalWithdrawalInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly createTransfer: (
    input: ExecutionEngineTransferInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly createBridge: (
    input: ExecutionEngineBridgeInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly createDepositIntent: (
    input: ExecutionEngineDepositIntentInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly attachDepositTransaction: (
    operationId: string,
    input: ExecutionEngineDepositAttachInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly getOperation: (
    operationId: string,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineOperation>;
  readonly getOperationLive: (
    operationId: string,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineLiveDescriptor>;
  readonly getPortfolioExecutionFeedLive: (
    portfolioId: string,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineLiveDescriptor>;
  readonly getUserExecutionFeedLive: (
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineUserFeedLiveDescriptor>;
  readonly postEvent: (
    operationId: string,
    input: ExecutionEngineEventInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineEventAck>;
  readonly postSettlementAck: (
    operationId: string,
    input: ExecutionEngineSettlementAckInput,
    options?: ExecutionEngineRequestOptions,
  ) => Promise<ExecutionEngineEventAck>;
  readonly subscribeLiveOperation: (
    operationId: string,
    input: ExecutionEngineLiveSubscriptionInput,
  ) => ExecutionEngineLiveSubscription;
  readonly subscribePortfolioExecutionFeed: (
    portfolioId: string,
    input: PortfolioExecutionFeedSubscriptionInput,
  ) => PortfolioExecutionFeedSubscription;
  readonly subscribeUserExecutionFeed: (
    userId: string,
    input: UserExecutionFeedSubscriptionInput,
  ) => UserExecutionFeedSubscription;
};

export type ConfiguredExecutionEngineClient = ExecutionEngineClient & {
  readonly lookupExactSelectionWithdrawal: NonNullable<
    ExecutionEngineClient["lookupExactSelectionWithdrawal"]
  >;
  readonly createExactSelectionWithdrawal: NonNullable<
    ExecutionEngineClient["createExactSelectionWithdrawal"]
  >;
  readonly getCanonicalSellMax: NonNullable<
    ExecutionEngineClient["getCanonicalSellMax"]
  >;
  readonly previewCanonicalSell: NonNullable<
    ExecutionEngineClient["previewCanonicalSell"]
  >;
  readonly createCanonicalSell: NonNullable<
    ExecutionEngineClient["createCanonicalSell"]
  >;
  readonly createOwnerUsdcWithdrawal: NonNullable<
    ExecutionEngineClient["createOwnerUsdcWithdrawal"]
  >;
  readonly previewOwnerWithdrawal: NonNullable<
    ExecutionEngineClient["previewOwnerWithdrawal"]
  >;
  readonly previewOwnerUsdcWithdrawal: NonNullable<
    ExecutionEngineClient["previewOwnerUsdcWithdrawal"]
  >;
  readonly previewExternalWithdrawal: NonNullable<
    ExecutionEngineClient["previewExternalWithdrawal"]
  >;
  readonly previewWithdrawal: NonNullable<
    ExecutionEngineClient["previewWithdrawal"]
  >;
  readonly createExternalWithdrawal: NonNullable<
    ExecutionEngineClient["createExternalWithdrawal"]
  >;
  readonly createOwnerWithdrawal: NonNullable<
    ExecutionEngineClient["createOwnerWithdrawal"]
  >;
  readonly getWithdrawalBalances: NonNullable<
    ExecutionEngineClient["getWithdrawalBalances"]
  >;
  readonly getTradeMax: NonNullable<ExecutionEngineClient["getTradeMax"]>;
  readonly createRebalance: NonNullable<
    ExecutionEngineClient["createRebalance"]
  >;
  readonly previewAssetTrade: NonNullable<
    ExecutionEngineClient["previewAssetTrade"]
  >;
  readonly createAssetTrade: NonNullable<
    ExecutionEngineClient["createAssetTrade"]
  >;
  readonly getCanonicalSellProgress: NonNullable<
    ExecutionEngineClient["getCanonicalSellProgress"]
  >;
  readonly getAssetTradeFunding: NonNullable<
    ExecutionEngineClient["getAssetTradeFunding"]
  >;
};

export type ExecutionEngineLiveSubscriptionInput = {
  readonly lastSequence?: number;
  readonly token?: string | null;
  readonly onSnapshot?: (snapshot: ExecutionLiveSnapshot) => void;
  readonly onEvent?: (event: ExecutionLiveEvent) => void;
  readonly onReplayOverflow?: () => void;
  readonly onError?: (error: ExecutionEngineClientError) => void;
  readonly onClose?: (event: CloseEvent) => void;
  readonly WebSocketImpl?: WebSocketConstructorLike;
};

export type ExecutionEngineLiveSubscription = {
  readonly url: string;
  readonly close: () => void;
  readonly send: (message: ExecutionLiveClientMessage) => void;
};

export type PortfolioExecutionFeedSubscriptionInput = {
  readonly lastSequence?: number;
  readonly token?: string | null;
  readonly onSnapshot?: (snapshot: PortfolioExecutionFeedSnapshot) => void;
  readonly onOperation?: (operation: PortfolioExecutionFeedOperation) => void;
  readonly onReplayOverflow?: () => void;
  readonly onError?: (error: ExecutionEngineClientError) => void;
  readonly onClose?: (event: CloseEvent) => void;
  readonly WebSocketImpl?: WebSocketConstructorLike;
};

export type PortfolioExecutionFeedSubscription = {
  readonly url: string;
  readonly close: () => void;
  readonly send: (message: PortfolioExecutionFeedClientMessage) => void;
};

export type UserExecutionFeedSubscriptionInput = {
  readonly lastSequence?: number;
  readonly token?: string | null;
  readonly onSnapshot?: (snapshot: UserExecutionFeedSnapshot) => void;
  readonly onOperation?: (operation: UserExecutionFeedOperation) => void;
  readonly onReplayOverflow?: () => void;
  readonly onError?: (error: ExecutionEngineClientError) => void;
  readonly onClose?: (event: CloseEvent) => void;
  readonly WebSocketImpl?: WebSocketConstructorLike;
};

export type UserExecutionFeedSubscription = {
  readonly url: string;
  readonly close: () => void;
  readonly send: (message: UserExecutionFeedClientMessage) => void;
};

/** A repayment priced for another selection must never stand for this one. */
const requireOwnerPreviewScope = (
  input: {
    readonly portfolioId: string;
    readonly assets: readonly {
      readonly accountRef: string;
      readonly assetId: string;
      readonly amountRaw: string;
    }[];
  },
  preview: ExecutionEngineOwnerWithdrawalPreview,
): ExecutionEngineOwnerWithdrawalPreview => {
  const key = (assets: typeof input.assets) =>
    JSON.stringify(
      assets.map(({ accountRef, assetId, amountRaw }) => [
        accountRef,
        assetId,
        amountRaw,
      ]),
    );
  if (
    preview.portfolioId !== input.portfolioId ||
    key(preview.assets) !== key(input.assets)
  )
    throw new Error("owner_withdrawal_preview_scope_mismatch");
  return preview;
};

export const createExecutionEngineClient = (input: {
  readonly baseUrl: string | null | undefined;
  readonly headers?: HeaderProvider;
  readonly onCapabilityUnauthorized?: CapabilityUnauthorizedHandler;
  readonly requestTimeoutMs?: number | null | undefined;
  readonly fetchImpl?: FetchLike;
}): ConfiguredExecutionEngineClient | null => {
  const baseUrl = normalizeOptionalString(input.baseUrl);
  if (!baseUrl) {
    return null;
  }

  const normalizedBaseUrl = normalizeBaseUrl(baseUrl);
  const fetchImpl = input.fetchImpl ?? fetch;
  const configuredRequestTimeoutMs =
    typeof input.requestTimeoutMs === "number" && input.requestTimeoutMs > 0
      ? input.requestTimeoutMs
      : null;
  const requestTimeoutMs =
    configuredRequestTimeoutMs ?? DEFAULT_REQUEST_TIMEOUT_MS;

  const resolveHeaders = async (
    context: ExecutionEngineRequestContext,
  ): Promise<Record<string, string> | undefined> => {
    const authHeaders = (await input.headers?.(context)) ?? {};
    const bodyCorrelationId = (() => {
      if (!context.body) {
        return null;
      }
      try {
        const raw: unknown = JSON.parse(context.body);
        const parsed = z
          .object({
            correlationId: ExecutionCorrelationIdSchema.optional(),
          })
          .passthrough()
          .safeParse(raw);
        return parsed.success ? (parsed.data.correlationId ?? null) : null;
      } catch {
        return null;
      }
    })();
    const optionCorrelationId = ExecutionCorrelationIdSchema.safeParse(
      context.options?.telemetry?.correlationId,
    );
    const correlationId =
      bodyCorrelationId ??
      (optionCorrelationId.success ? optionCorrelationId.data : null);
    const clientInteractionId =
      normalizeOptionalString(
        context.options?.telemetry?.clientInteractionId,
      ) ?? correlationId;
    const telemetryHeaders = {
      ...(clientInteractionId
        ? { "x-client-interaction-id": clientInteractionId }
        : {}),
      ...(correlationId ? { "x-correlation-id": correlationId } : {}),
      "x-request-id": `req_${globalThis.crypto.randomUUID()}`,
    };
    if (context.method === "POST") {
      return {
        ...authHeaders,
        "content-type": "application/json",
        ...telemetryHeaders,
      };
    }

    return {
      ...authHeaders,
      ...telemetryHeaders,
    };
  };

  const send = async (params: {
    readonly path: string;
    readonly method: "GET" | "POST";
    readonly body?: string;
    readonly options?: ExecutionEngineRequestOptions;
    readonly timeoutMs?: number;
  }): Promise<Response> =>
    // A route's own budget (`timeoutMs`, the order admission) comes first;
    // then a caller's per-request budget; then the client default.
    await withTimeout(
      params.timeoutMs ??
        (typeof params.options?.requestTimeoutMs === "number" &&
        params.options.requestTimeoutMs > 0
          ? params.options.requestTimeoutMs
          : requestTimeoutMs),
      async (signal) => {
        const context: ExecutionEngineRequestContext = {
          body: params.body,
          method: params.method,
          options: params.options,
          path: params.path,
        };
        return await fetchImpl(`${normalizedBaseUrl}${params.path}`, {
          method: params.method,
          headers: await resolveHeaders(context),
          body: params.body,
          signal: params.options?.signal
            ? AbortSignal.any([signal, params.options.signal])
            : signal,
        });
      },
    );

  const isCapabilitySpecificUnauthorized = async (
    response: Response,
  ): Promise<boolean> => {
    if (response.status !== 401 || !input.onCapabilityUnauthorized) {
      return false;
    }

    const { details } = await readErrorPayload(response.clone());
    const error = details?.error;
    return typeof error === "string" && error.startsWith("capability_");
  };

  const sendWithCapabilityRetry = async (params: {
    readonly path: string;
    readonly method: "GET" | "POST";
    readonly body?: string;
    readonly options?: ExecutionEngineRequestOptions;
    readonly timeoutMs?: number;
  }): Promise<Response> => {
    const response = await send(params);
    if (!(await isCapabilitySpecificUnauthorized(response))) {
      return response;
    }

    await input.onCapabilityUnauthorized?.({
      body: params.body,
      method: params.method,
      options: params.options,
      path: params.path,
    });
    return await send(params);
  };

  const requireOk = async <TOutput, TInput>(
    response: Response,
    schema: z.ZodType<TOutput, TInput>,
  ): Promise<TOutput> => {
    if (!response.ok) {
      const { message, details } = await readErrorPayload(response);
      throw new ExecutionEngineClientError(
        message,
        response.status === 404
          ? "EXECUTION_ENGINE_NOT_FOUND"
          : "EXECUTION_ENGINE_REQUEST_FAILED",
        response.status,
        details,
      );
    }

    const payload = await response.json();
    const parsed = schema.safeParse(payload);
    if (!parsed.success) {
      throw new ExecutionEngineClientError(
        "execution_engine_invalid_response",
        "EXECUTION_ENGINE_INVALID_RESPONSE",
      );
    }

    return parsed.data;
  };

  async function createOperation(
    rawInput: ExecutionEngineCreateInput,
    options?: ExecutionEngineRequestOptions,
  ): Promise<ExecutionEngineOperation>;
  async function createOperation(
    rawInput: IdleAssetReconciliationCreate,
    options?: ExecutionEngineRequestOptions,
  ): Promise<ExecutionEngineOperation | IdleAssetReconciliationNoOp>;
  async function createOperation(
    rawInput: ExecutionEngineCreateInput | IdleAssetReconciliationCreate,
    options?: ExecutionEngineRequestOptions,
  ): Promise<ExecutionEngineOperation | IdleAssetReconciliationNoOp> {
    const isIntent = "intent" in rawInput;
    const payload = isIntent
      ? IdleAssetReconciliationCreateSchema.parse(rawInput)
      : executionOperationCreateSchema.parse(rawInput);
    const response = await sendWithCapabilityRetry({
      path: "/execution/operations",
      method: "POST",
      body: JSON.stringify(payload),
      options,
    });
    return isIntent
      ? requireOk(
          response,
          z.union([
            IdleAssetReconciliationNoOpSchema,
            ExecutionOperationResponseSchema,
          ]),
        )
      : requireOk(response, ExecutionOperationResponseSchema);
  }

  return {
    getPortfolioCashFunding: async (portfolioId, options) =>
      requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/portfolio-cash/${encodeURIComponent(portfolioId)}`,
          method: "GET",
          options: {
            ...options,
            capability: {
              ...options?.capability,
              portfolioIds: [portfolioId],
              scopes: ["quote:read"],
            },
          },
        }),
        PortfolioCashFundingSchema,
      ),
    createPortfolioOrder: async (rawInput, options) => {
      const input = PortfolioOrderCreateSchema.parse(rawInput);
      return requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/portfolio-orders",
          timeoutMs:
            configuredRequestTimeoutMs ?? PORTFOLIO_ORDER_ADMISSION_TIMEOUT_MS,
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        PortfolioOrderCreatedSchema,
      );
    },
    getPortfolioOrder: async (portfolioId, operationId, options) => {
      return requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/portfolio-orders/${encodeURIComponent(portfolioId)}/${encodeURIComponent(operationId)}`,
          method: "GET",
          options,
        }),
        PortfolioOrderSchema,
      );
    },
    createOperation,
    createRebalance: async (rawInput, options) => {
      const input = rebalanceCreateSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/rebalances",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionRebalanceCreateResponseSchema,
      );
    },
    getCanonicalSellMax: async (rawInput, options) => {
      const input = CanonicalSellMaxRequestSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/trades/max",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        CanonicalSellMaxResponseSchema,
      );
      if (
        result.portfolioId !== input.portfolioId ||
        result.assetCanonicalId !== input.assetCanonicalId
      ) {
        throw new Error("trade_max_response_scope_mismatch");
      }
      return result;
    },
    previewCanonicalSell: async (rawInput, options) => {
      const input = CanonicalSellPreviewRequestSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/trades/preview",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        CanonicalSellPreviewResponseSchema,
      );
      if (
        result.portfolioId !== input.portfolioId ||
        result.assetCanonicalId !== input.assetCanonicalId
      ) {
        throw new Error("trade_preview_response_scope_mismatch");
      }
      return result;
    },
    createCanonicalSell: async (rawInput, options) => {
      const input = CanonicalSellCreateRequestSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/trades",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        CanonicalSellOperationResponseSchema,
      );
    },
    previewAssetTrade: async (rawInput, options) => {
      const input = AssetTradePreviewRequestSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/trades/preview",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        AssetTradePreviewResponseSchema,
      );
    },
    createAssetTrade: async (rawInput, options) => {
      const input = AssetTradeCreateRequestSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/trades",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        AssetTradeOperationResponseSchema,
      );
    },
    getWithdrawalBalances: async (rawInput, options) => {
      const input = WithdrawalBalancesInputSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/withdrawals/balances",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        WithdrawalBalancesSchema,
      );
      if (
        result.portfolioId !== input.portfolioId ||
        result.accountRefs.length !== input.accountRefs.length ||
        result.accountRefs.some(
          (account, index) => account !== input.accountRefs[index],
        )
      )
        throw new Error("withdrawal_balances_response_scope_mismatch");
      return result;
    },
    getTradeMax: async (rawInput, options) => {
      const input = AssetTradeMaxRequestSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/trades/max",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        AssetTradeMaxResponseSchema,
      );
      // A Max for another portfolio, asset or side must never size this one.
      if (
        result.portfolioId !== input.portfolioId ||
        result.assetId !== input.assetId ||
        result.side !== input.side
      ) {
        throw new Error("trade_max_response_scope_mismatch");
      }
      return result;
    },
    getCanonicalSellProgress: async (operationId, options) =>
      requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/trades/${encodeURIComponent(operationId)}/sell`,
          method: "GET",
          options,
        }),
        CanonicalSellProgressSchema,
      ),
    getAssetTradeFunding: async (operationId, options) =>
      (
        await requireOk(
          await sendWithCapabilityRetry({
            path: `/execution/trades/${encodeURIComponent(operationId)}/funding`,
            method: "GET",
            options,
          }),
          AssetTradeFundingRecoveryResponseSchema,
        )
      ).funding,
    createOndoDirectBatchRebalance: async (rawInput, options) => {
      const input = executionOndoDirectBatchRebalanceCreateSchema.parse(
        normalizeOndoDirectZeroMinimums(rawInput),
      );
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/ondo-direct/rebalances",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
    },
    createOndoDirectRebalanceFromTargets: async (rawInput, options) => {
      const input =
        executionOndoDirectRebalancePlanCreateSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/ondo-direct/rebalances",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
    },
    previewOndoDirectRebalancePlan: async (rawInput, options) => {
      const input =
        executionOndoDirectRebalancePlanPreviewRequestSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/ondo-direct/rebalances/preview",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOndoDirectRebalancePlanPreviewSchema,
      );
    },
    previewExternalWithdrawal: async (rawInput, options) => {
      const input =
        executionExternalWithdrawalPreviewInputSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/withdrawals/external/preview",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        executionExternalWithdrawalPreviewSchema,
      );
      if (
        result.portfolioId !== input.portfolioId ||
        result.expectedOwnerAddress !== input.expectedOwnerAddress ||
        result.recipient !== input.recipient ||
        result.assets.length !== input.assets.length ||
        result.assets.some((asset, index) => {
          const selected = input.assets[index];
          return (
            !selected ||
            asset.accountRef !== selected.accountRef ||
            asset.assetId !== selected.assetId ||
            asset.amountRaw !== selected.amountRaw
          );
        })
      )
        throw new Error("external_withdrawal_preview_scope_mismatch");
      return result;
    },
    createExternalWithdrawal: async (rawInput, options) => {
      const input = executionExternalWithdrawalCreateSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/withdrawals/external",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
      if (
        result.portfolioId !== input.portfolioId ||
        result.requestKey !== input.requestKey ||
        result.kind !== "withdraw"
      )
        throw new Error("external_withdrawal_response_scope_mismatch");
      return result;
    },
    lookupExactSelectionWithdrawal: async (rawInput, options) => {
      const input = exactSelectionWithdrawalIdentitySchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/operations/lookup",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        exactSelectionWithdrawalAckSchema.nullable(),
      );
      if (
        result &&
        (result.portfolioId !== input.portfolioId ||
          result.requestKey !== input.requestKey)
      )
        throw new Error("exact_selection_withdrawal_response_scope_mismatch");
      return result;
    },
    createExactSelectionWithdrawal: async (rawInput, options) => {
      const input = exactSelectionWithdrawalCreateSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/operations",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        exactSelectionWithdrawalAckSchema,
      );
      if (
        result.portfolioId !== input.portfolioId ||
        result.requestKey !== input.requestKey
      )
        throw new Error("exact_selection_withdrawal_response_scope_mismatch");
      return result;
    },
    createOwnerUsdcWithdrawal: async (rawInput, options) => {
      const input = executionOwnerUsdcWithdrawalCreateSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/withdrawals/usdc/owner",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
      if (
        result.portfolioId !== input.portfolioId ||
        result.requestKey !== input.requestKey ||
        result.kind !== "withdraw"
      )
        throw new Error("owner_usdc_withdrawal_response_scope_mismatch");
      return result;
    },
    createOwnerWithdrawal: async (rawInput, options) => {
      const input = executionOwnerWithdrawalCreateSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/withdrawals/owner",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
      if (
        result.portfolioId !== input.portfolioId ||
        result.requestKey !== input.requestKey ||
        result.kind !== "withdraw"
      )
        throw new Error("owner_withdrawal_response_scope_mismatch");
      return result;
    },
    previewOwnerWithdrawal: async (rawInput, options) => {
      const input = executionOwnerWithdrawalPreviewInputSchema.parse(rawInput);
      return requireOwnerPreviewScope(
        input,
        await requireOk(
          await sendWithCapabilityRetry({
            path: "/execution/withdrawals/owner/preview",
            method: "POST",
            body: JSON.stringify(input),
            options,
          }),
          executionOwnerWithdrawalPreviewSchema,
        ),
      );
    },
    previewOwnerUsdcWithdrawal: async (rawInput, options) => {
      const input =
        executionOwnerUsdcWithdrawalPreviewInputSchema.parse(rawInput);
      return requireOwnerPreviewScope(
        input,
        await requireOk(
          await sendWithCapabilityRetry({
            path: "/execution/withdrawals/usdc/owner/preview",
            method: "POST",
            body: JSON.stringify(input),
            options,
          }),
          executionOwnerWithdrawalPreviewSchema,
        ),
      );
    },
    previewWithdrawal: async (rawInput, options) => {
      const input = executionWithdrawalPreviewInputSchema.parse(rawInput);
      const result = await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/withdrawals/preview",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        executionWithdrawalPreviewSchema,
      );
      // A preview for another intent must never price this one.
      if (
        result.portfolioId !== input.portfolioId ||
        result.chainId !== input.chainId ||
        result.assetId !== input.assetId ||
        result.amount !== input.amount ||
        result.recipient !== input.recipient
      )
        throw new Error("withdrawal_preview_scope_mismatch");
      return result;
    },
    createWithdrawal: async (rawInput, options) => {
      const input = executionWithdrawalCreateSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/withdrawals",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
    },
    createTransfer: async (rawInput, options) => {
      const input = executionTransferCreateSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/transfers",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
    },
    createBridge: async (rawInput, options) => {
      const input = executionBridgeCreateSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/bridges",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
    },
    createDepositIntent: async (rawInput, options) => {
      const input = executionDepositIntentCreateSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/deposits",
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
    },
    attachDepositTransaction: async (operationId, rawInput, options) => {
      const input = executionDepositTransactionAttachSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/deposits/${encodeURIComponent(
            operationId,
          )}/transaction`,
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationResponseSchema,
      );
    },
    getOperation: async (operationId, options) =>
      await requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/operations/${encodeURIComponent(operationId)}`,
          method: "GET",
          options,
        }),
        ExecutionOperationResponseSchema,
      ),
    getOperationLive: async (operationId, options) =>
      await requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/operations/${encodeURIComponent(
            operationId,
          )}/live-descriptor`,
          method: "GET",
          options,
        }),
        LiveDescriptorSchema,
      ),
    getPortfolioExecutionFeedLive: async (portfolioId, options) =>
      await requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/portfolios/${encodeURIComponent(
            portfolioId,
          )}/live-descriptor`,
          method: "GET",
          options,
        }),
        LiveDescriptorSchema,
      ),
    getUserExecutionFeedLive: async (options) =>
      await requireOk(
        await sendWithCapabilityRetry({
          path: "/execution/users/me/activity/live-descriptor",
          method: "GET",
          options,
        }),
        UserFeedLiveDescriptorSchema,
      ),
    postEvent: async (operationId, rawInput, options) => {
      const input = executionOperationEventSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/operations/${encodeURIComponent(operationId)}/events`,
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationEventAckSchema,
      );
    },
    postSettlementAck: async (operationId, rawInput, options) => {
      const input = executionOperationSettlementAckSchema.parse(rawInput);
      return await requireOk(
        await sendWithCapabilityRetry({
          path: `/execution/operations/${encodeURIComponent(
            operationId,
          )}/settlement`,
          method: "POST",
          body: JSON.stringify(input),
          options,
        }),
        ExecutionOperationEventAckSchema,
      );
    },
    subscribeLiveOperation: (operationId, subscriptionInput) => {
      const WebSocketImpl = subscriptionInput.WebSocketImpl ?? WebSocket;
      const url = buildExecutionLiveWebSocketUrl({
        baseUrl: normalizedBaseUrl,
        operationId,
      });
      const socket = new WebSocketImpl(
        url,
        buildExecutionFeedSubprotocols(subscriptionInput.token),
      );
      const liveness = createLivenessGuard(socket);

      const sendLiveMessage = (message: ExecutionLiveClientMessage): void => {
        socket.send(
          JSON.stringify(ExecutionLiveClientMessageSchema.parse(message)),
        );
      };

      const onOpen = (): void => {
        sendLiveMessage({
          kind: "hello",
          ...(subscriptionInput.lastSequence === undefined
            ? {}
            : { lastSequence: subscriptionInput.lastSequence }),
        });
        liveness.start();
      };
      const onMessage = (event: MessageEvent): void => {
        if (typeof event.data !== "string") {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "execution_live_binary_message_unsupported",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        // Any frame proves the socket is alive; re-arm the stale watchdog first.
        liveness.noteActivity();

        let raw: unknown;
        try {
          raw = JSON.parse(event.data) as unknown;
        } catch {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "execution_live_invalid_json",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        // Keepalive acks are transport control frames outside the feed schema;
        // liveness is already recorded, so consume them silently.
        if (isKeepaliveAck(raw)) {
          return;
        }

        if (hasUnknownFrameKind(raw, executionLiveServerMessageKinds)) {
          return;
        }

        const parsed = ExecutionLiveServerMessageSchema.safeParse(raw);
        if (!parsed.success) {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "execution_live_invalid_message",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        switch (parsed.data.kind) {
          case "snapshot":
            subscriptionInput.onSnapshot?.(parsed.data.payload);
            break;
          case "event":
            // No per-event ack: it woke the hibernated DO N× per broadcast just
            // to hit an ignore branch (M3). The server still accepts acks for
            // forward-compat, but the client no longer sends them.
            subscriptionInput.onEvent?.(parsed.data.payload);
            break;
          case "error":
            if (parsed.data.code === "replay_overflow") {
              subscriptionInput.onReplayOverflow?.();
              break;
            }
            subscriptionInput.onError?.(
              new ExecutionEngineClientError(
                parsed.data.message,
                "EXECUTION_ENGINE_REQUEST_FAILED",
                undefined,
                {
                  code: parsed.data.code,
                },
              ),
            );
            break;
          case "pong":
            break;
        }
      };
      const onCloseInternal = (event: CloseEvent): void => {
        liveness.dispose();
        subscriptionInput.onClose?.(event);
      };

      socket.addEventListener("open", onOpen);
      socket.addEventListener("message", onMessage);
      socket.addEventListener("close", onCloseInternal);

      return {
        url,
        close: () => {
          liveness.dispose();
          socket.removeEventListener("open", onOpen);
          socket.removeEventListener("message", onMessage);
          socket.removeEventListener("close", onCloseInternal);
          socket.close();
        },
        send: sendLiveMessage,
      };
    },
    subscribePortfolioExecutionFeed: (portfolioId, subscriptionInput) => {
      const WebSocketImpl = subscriptionInput.WebSocketImpl ?? WebSocket;
      const url = buildPortfolioExecutionFeedWebSocketUrl({
        baseUrl: normalizedBaseUrl,
        portfolioId,
      });
      const socket = new WebSocketImpl(
        url,
        buildExecutionFeedSubprotocols(subscriptionInput.token),
      );
      const liveness = createLivenessGuard(socket);

      const sendFeedMessage = (
        message: PortfolioExecutionFeedClientMessage,
      ): void => {
        socket.send(
          JSON.stringify(
            PortfolioExecutionFeedClientMessageSchema.parse(message),
          ),
        );
      };

      const onOpen = (): void => {
        sendFeedMessage({
          kind: "hello",
          ...(subscriptionInput.lastSequence === undefined
            ? {}
            : { lastSequence: subscriptionInput.lastSequence }),
        });
        liveness.start();
      };
      const onMessage = (event: MessageEvent): void => {
        if (typeof event.data !== "string") {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "portfolio_execution_feed_binary_message_unsupported",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        liveness.noteActivity();

        let raw: unknown;
        try {
          raw = JSON.parse(event.data) as unknown;
        } catch {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "portfolio_execution_feed_invalid_json",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        if (isKeepaliveAck(raw)) {
          return;
        }

        if (
          hasUnknownFrameKind(raw, portfolioExecutionFeedServerMessageKinds)
        ) {
          return;
        }

        const parsed = PortfolioExecutionFeedServerMessageSchema.safeParse(raw);
        if (!parsed.success) {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "portfolio_execution_feed_invalid_message",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        switch (parsed.data.kind) {
          case "snapshot":
            subscriptionInput.onSnapshot?.(parsed.data.payload);
            break;
          case "operation":
            // M3: no per-operation ack (see subscribeLiveOperation).
            subscriptionInput.onOperation?.(parsed.data.payload);
            break;
          case "error":
            if (parsed.data.code === "replay_overflow") {
              subscriptionInput.onReplayOverflow?.();
              break;
            }
            subscriptionInput.onError?.(
              new ExecutionEngineClientError(
                parsed.data.message,
                "EXECUTION_ENGINE_REQUEST_FAILED",
                undefined,
                {
                  code: parsed.data.code,
                },
              ),
            );
            break;
          case "pong":
            break;
        }
      };
      const onCloseInternal = (event: CloseEvent): void => {
        liveness.dispose();
        subscriptionInput.onClose?.(event);
      };

      socket.addEventListener("open", onOpen);
      socket.addEventListener("message", onMessage);
      socket.addEventListener("close", onCloseInternal);

      return {
        url,
        close: () => {
          liveness.dispose();
          socket.removeEventListener("open", onOpen);
          socket.removeEventListener("message", onMessage);
          socket.removeEventListener("close", onCloseInternal);
          socket.close();
        },
        send: sendFeedMessage,
      };
    },
    subscribeUserExecutionFeed: (userId, subscriptionInput) => {
      const WebSocketImpl = subscriptionInput.WebSocketImpl ?? WebSocket;
      const url = buildUserExecutionFeedWebSocketUrl({
        baseUrl: normalizedBaseUrl,
        userId,
      });
      const socket = new WebSocketImpl(
        url,
        buildExecutionFeedSubprotocols(subscriptionInput.token),
      );
      const liveness = createLivenessGuard(socket);

      const sendFeedMessage = (
        message: UserExecutionFeedClientMessage,
      ): void => {
        socket.send(
          JSON.stringify(UserExecutionFeedClientMessageSchema.parse(message)),
        );
      };

      const onOpen = (): void => {
        sendFeedMessage({
          kind: "hello",
          ...(subscriptionInput.lastSequence === undefined
            ? {}
            : { lastSequence: subscriptionInput.lastSequence }),
        });
        liveness.start();
      };
      const onMessage = (event: MessageEvent): void => {
        if (typeof event.data !== "string") {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "user_execution_feed_binary_message_unsupported",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        liveness.noteActivity();

        let raw: unknown;
        try {
          raw = JSON.parse(event.data) as unknown;
        } catch {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "user_execution_feed_invalid_json",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        if (isKeepaliveAck(raw)) {
          return;
        }

        if (hasUnknownFrameKind(raw, userExecutionFeedServerMessageKinds)) {
          return;
        }

        const parsed = UserExecutionFeedServerMessageSchema.safeParse(raw);
        if (!parsed.success) {
          subscriptionInput.onError?.(
            new ExecutionEngineClientError(
              "user_execution_feed_invalid_message",
              "EXECUTION_ENGINE_INVALID_RESPONSE",
            ),
          );
          return;
        }

        switch (parsed.data.kind) {
          case "snapshot":
            subscriptionInput.onSnapshot?.(parsed.data.payload);
            break;
          case "operation":
            // M3: no per-operation ack (see subscribeLiveOperation).
            subscriptionInput.onOperation?.(parsed.data.payload);
            break;
          case "error":
            if (parsed.data.code === "replay_overflow") {
              subscriptionInput.onReplayOverflow?.();
              break;
            }
            subscriptionInput.onError?.(
              new ExecutionEngineClientError(
                parsed.data.message,
                "EXECUTION_ENGINE_REQUEST_FAILED",
                undefined,
                {
                  code: parsed.data.code,
                },
              ),
            );
            break;
          case "pong":
            break;
        }
      };
      const onCloseInternal = (event: CloseEvent): void => {
        liveness.dispose();
        subscriptionInput.onClose?.(event);
      };

      socket.addEventListener("open", onOpen);
      socket.addEventListener("message", onMessage);
      socket.addEventListener("close", onCloseInternal);

      return {
        url,
        close: () => {
          liveness.dispose();
          socket.removeEventListener("open", onOpen);
          socket.removeEventListener("message", onMessage);
          socket.removeEventListener("close", onCloseInternal);
          socket.close();
        },
        send: sendFeedMessage,
      };
    },
  };
};

export {
  executionBridgeCreateSchema,
  executionDepositIntentCreateSchema,
  executionDepositTransactionAttachSchema,
  executionOndoDirectBatchRebalanceCreateSchema,
  executionOndoDirectRebalancePlanCreateSchema,
  executionOndoDirectRebalancePlanPreviewRequestSchema,
  executionOperationCreateSchema,
  executionOperationEventSchema,
  executionOperationSettlementAckSchema,
  executionTransferCreateSchema,
  executionWithdrawalCreateSchema,
  rebalanceCreateSchema,
};
